import { updateComplianceMonitor } from './updateComplianceMonitor';
import { ComplianceMonitorCorporationInfoOnboardingStatus } from './compliance-monitor.types';

/**
 * Marks a corporation's compliance-monitor onboarding fully complete. Called when the Tax &
 * Accounting onboarding finishes (it has already generated the calendar), so the Compliance
 * Calendar page shows the calendar instead of forcing the legacy onboarding/generation.
 *
 * Completion is a declarative state transition on the compliance-monitor resource, so it goes
 * through the standard update endpoint (`status: COMPLETED`, server marks every step finished)
 * rather than a dedicated RPC-style endpoint.
 */
export async function completeComplianceMonitorOnboarding(
  corporationId: number
): Promise<Response | null> {
  return updateComplianceMonitor(corporationId, {
    onboardingInformation: {
      status: ComplianceMonitorCorporationInfoOnboardingStatus.COMPLETED,
    },
  });
}
